var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "p-6 bg-gray-50 rounded-lg shadow-md",
      attrs: { id: "VisitorMediaAndDocuments" },
    },
    [
      _vm.loading
        ? _c("div", { staticClass: "loading-spinner" })
        : _c("div", [
            _c("div", { staticClass: "tab-menu mb-6" }, [
              _c(
                "div",
                { staticClass: "flex space-x-4" },
                _vm._l(_vm.tabs, function (tab, index) {
                  return _c(
                    "button",
                    {
                      key: index,
                      class: [
                        "tab-btn",
                        _vm.activeTab === tab.id ? "active" : "",
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.handleTabClick(tab.id)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex items-center space-x-2" },
                        [
                          _c("i", { staticClass: "text-sm", class: tab.icon }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "text-base font-semibold" },
                            [_vm._v(_vm._s(tab.name))]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tab-content" }, [
              _vm.activeTab === "images"
                ? _c("div", [
                    _vm.images.length === 0
                      ? _c("div", { staticClass: "empty-state" }, [
                          _c(
                            "svg",
                            {
                              staticClass: "empty-icon",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-gray-500" }, [
                            _vm._v(_vm._s(_vm.$t("message.noMediaDocuments"))),
                          ]),
                        ])
                      : _c(
                          "div",
                          { staticClass: "image-grid" },
                          [
                            _vm.selectedImages.length > 0
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "download-button",
                                    on: { click: _vm.downloadSelectedImages },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("message.download")) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.images, function (image, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "image-item" },
                                [
                                  _c(
                                    "viewer",
                                    {
                                      attrs: {
                                        images: _vm.images.map(function (
                                          image
                                        ) {
                                          return image.url
                                        }),
                                      },
                                    },
                                    [
                                      _c("input", {
                                        attrs: {
                                          type: "checkbox",
                                          disabled:
                                            _vm.isSelectionLimitReached &&
                                            !_vm.selectedImages.includes(
                                              image.url
                                            ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.toggleImageSelection(
                                              image.url
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("img", {
                                        staticClass: "image",
                                        attrs: {
                                          id: "img-" + index,
                                          src: image.url,
                                          alt: image.name,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "image-overlay",
                                          on: {
                                            click: function ($event) {
                                              return _vm.show(index)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "image-name" },
                                            [_vm._v(_vm._s(image.name))]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.activeTab === "files"
                ? _c("div", [
                    _vm.files.length === 0
                      ? _c("div", { staticClass: "empty-state" }, [
                          _c(
                            "svg",
                            {
                              staticClass: "empty-icon",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-gray-500" }, [
                            _vm._v(_vm._s(_vm.$t("message.noMediaDocuments"))),
                          ]),
                        ])
                      : _c(
                          "div",
                          { staticClass: "file-list space-y-3" },
                          [
                            _vm.selectedFiles.length > 0
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "download-button",
                                    on: { click: _vm.downloadSelectedFiles },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.$t("message.download")) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.files, function (file, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "file-item" },
                                [
                                  _c("input", {
                                    attrs: {
                                      type: "checkbox",
                                      disabled:
                                        _vm.isSelectionLimitReached &&
                                        !_vm.selectedFiles.includes(file.url),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.toggleFileSelection(file.url)
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fas fa-file-alt file-icon",
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "file-info" }, [
                                    _c("p", { staticClass: "file-name" }, [
                                      _vm._v(_vm._s(file.name)),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "file-size" }, [
                                      _vm._v(_vm._s(file.size)),
                                    ]),
                                  ]),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                  ])
                : _vm._e(),
            ]),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }